import { Injectable } from '@angular/core';
import { createSelector } from '@ngrx/store';
import { SafariReduxPageUiObject, defaultPageUiState } from '@safarilaw-webapp/shared/redux';
import { getSharedFeatureState } from '../../../redux/state.selector';
import { CompanyEntityEditEditPageUiState } from './interface';

@Injectable({ providedIn: 'root' })
export class LpmsCompanyEntityEditEditPageReduxUiObject extends SafariReduxPageUiObject<CompanyEntityEditEditPageUiState> {
  // Doing this to prevent the compiler from complaining. We will be getting rid of this default
  // thing but this makes it compile for now
  default = {};

  constructor() {
    const getPageState = createSelector(getSharedFeatureState, state => state.pages.companyEntityEditPage);
    super('Lpms', 'Company Entity Edit', getPageState, defaultPageUiState);
  }
}
